import markerSDK, { MarkerSdk } from '@marker.io/browser'
import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react'

type IReporter = {
  email: string
  fullName: string
}

type IMarkerContext = {
  marker: MarkerSdk | null
  setReporter: (reporter: IReporter | null) => void
}

const MarkerContext = createContext<IMarkerContext>({} as IMarkerContext)

export const useMarker = () => {
  const context = useContext(MarkerContext)
  if (context === undefined) {
    throw new Error('useMarker must be used within a MarkerProvider')
  }
  return context
}

interface MarkerProviderProps {
  children: ReactNode
}

export const MarkerProvider: React.FC<MarkerProviderProps> = ({ children }: MarkerProviderProps) => {
  const [marker, setMarker] = useState<MarkerSdk | null>(null)
  const [reporter, setReporter] = useState<IReporter | null>(null)

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      markerSDK.loadWidget({ project: '63d7f4f1218c1dc63183768a' }).then((widget: MarkerSdk) => {
        setMarker(widget)
      })
    }
  }, [])

  useEffect(() => {
    if (marker) {
      if (reporter) {
        marker.show()
      } else {
        marker.hide()
      }
    }
  }, [marker, reporter])

  useEffect(() => {
    if (marker && reporter) {
      marker.setReporter(reporter)
      marker.show()
    }
  }, [marker, reporter])

  return (
    <MarkerContext.Provider value={{ marker, setReporter }}>
      {children}
    </MarkerContext.Provider>
  )
}
